import { render, staticRenderFns } from "./PreDownPaymentTab.vue?vue&type=template&id=0fa286ea&scoped=true&"
import script from "./PreDownPaymentTab.vue?vue&type=script&lang=ts&"
export * from "./PreDownPaymentTab.vue?vue&type=script&lang=ts&"
import style0 from "./PreDownPaymentTab.vue?vue&type=style&index=0&id=0fa286ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa286ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VRow,VSimpleTable,VTextField})
